import { useRouter } from 'next/router';

/**
 * Returns the value of a query param from the router query object
 * if it is a string. Throws an error in other cases.
 * @param param string to search for in the query object
 * @returns the param as string if it exists in the query object
 * @throws an error if the param does not exist or is not a string
 * @example const id = useQueryParam('id');
 */
export const useQueryParam = (param: string): string => {
  const router = useRouter();
  const value = router.query[param];

  if (!param || typeof value !== 'string') {
    return '';
  }

  return value;
};
